import ComingSoon from '../components/ComingSoon';
import { getNavItem } from '../navigation';

const Marketing = () => <ComingSoon item={getNavItem('marketing')} />;

export default Marketing;
